import React, { useState, useCallback, useEffect } from 'react'
import { Typography, Button } from '@mui/material'
import useStyles from '../style1'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import MarqueeText from 'sharedComponents/marqueeText'
import homeApi from 'services/home'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch, useSelector } from 'react-redux'

const Caption = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const contactDetails = useSelector(
    (state) => state?.contactDetailsReducer?.contactDetails?.contactDetails
  )
  const [rates, setRates] = useState("")

  const phoneNumber = `91${contactDetails?.whatsappNo}` || ''
  const message = 'Send hi to start'

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

  // Get today metal rates api
  const getMetalRates = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setRates(
          res?.data?.data?.reduce(
            (acc, cur, index) =>
              (acc += `${index !== 0 ? "," : ""} ${cur?.category?.name} - Rs.${
                cur.rate
              }`),
            ""
          ) ?? ""
        );
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get today metal rates Api', err)
    }
    homeApi.getTodayRates().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getMetalRates()
  }, [getMetalRates])

  // Handle Virtual Tryon
  const loadMirrarUI = () => {
    let script = document.createElement('script')
    script.onload = () => {
      // Define your options
      let options = {
        brandId: '70fa3fe5-aefe-43bb-8c6b-8783277fe33f',
      }
      // Call the Mirrar UI initialization function
      window.initMirrarUI(sku, options)
    }
    script.src = 'https://cdn.mirrar.com/general/scripts/mirrar-ui.js'
    document.body.appendChild(script)
  }

  useEffect(() => {
    return () => {
      // Clean up any resources when the component unmounts
      // (e.g., remove event listeners, clear timeouts/intervals)
      // Here, you can remove the Mirrar UI script if needed
      let mirrarScript = document.querySelector(
        "script[src^='https://cdn.mirrar.com/general/scripts/mirrar-ui.js']"
      )
      if (mirrarScript) {
        mirrarScript.remove()
      }
    }
  }, [])

  const handleVirtualTryon = () => {
    loadMirrarUI()
  }

  const sku = {} // Provide the SKU value

  return (
    <>
      <section className={classes.wrapper}>
        <section className={classes.container}>
          <div className={classes.captionContainer}>
            <section className={classes.marqueeWrapper}>
              <Typography variant="body2">Today's Rate </Typography>
              <div className={classes.marqueeContainer}>
                <MarqueeText>
                  <div className={classes.marqueeText}>
                    <Typography variant="body2">
                      {rates}
                    </Typography>
                  </div>
                </MarqueeText>
              </div>
            </section>
            <section className={classes.captionBtnWrapper}>
              <div
                className={classes.captionText}
                onClick={() => window.open(url, '_blank')}
              >
                <Typography
                  variant="body2"
                  style={{ display: 'flex', alignItems: 'center', gap: 6 }}
                >
                  {contactDetails?.whatsappNo ? (
                    <>
                      {' '}
                      <WhatsAppIcon /> 91{contactDetails?.whatsappNo}
                    </>
                  ) : (
                    ''
                  )}
                </Typography>
              </div>
              {/* <div className={classes.tryOnBtn}>
                <Button
                  variant="outlined"
                  color="secondary"
                  disableElevation
                  id="tryOnButton"
                  onClick={handleVirtualTryon}
                >
                  <img
                    src="/assets/images/tryon.png"
                    alt="icon"
                    className={classes.tryOnImg}
                  />{' '}
                  Try Virtual Tryon
                </Button>
              </div> */}
            </section>
          </div>
        </section>
      </section>
    </>
  )
}

export default Caption
